import React, { useEffect, useState } from "react";
import NoPostSchedule from "../../NoPostSchedule";
import { useSelector } from "react-redux";
import dummylogo from "../../../../assets/img/dummylogo.png";
import { capitalizeWord, sortItem } from "../../../../utils/func";
import BarLoader from "../../../../components/Loaders/BarLoader";
import SocialChannelTopNav from "../SocialChannelTopNav";
import { addDays } from "date-fns";
import Table from "../../../../components/Table";
import format from "date-fns/format";
import TableDropdown from "../../../../components/Dropdown/TableDropdown";
import moment from "moment";

//redux
import { connect } from "react-redux";
import { deleteTwitterPost } from "../../../../redux/actions";
import { toast } from "react-toastify";
import DeleteModal from "../../../../components/Modal/DeleteModal";
import { truncateText } from "../../../../utils/helper";
import PreviewPost from "../../PreviewPost";

const TwitterPost = (props) => {
  const {
    id,
    deleteTwitterPost,
    deleteTwitterMessage,
    deleteTwitterError,
    deleteTwitterloading,
  } = props;
  const { getOneClientPostLoading, getOneClientPost } = useSelector(
    (state) => state?.postSchedule
  );

  const sortedTwitterData = sortItem(getOneClientPost?.user_twitter_post);

  const [searchValue, setSearchValue] = useState("");
  const [twitterData, setTwitterData] = useState();
  const [selectedValue, setSelectedValue] = useState("all");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deletePayload, setDeletePayload] = useState(null);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [previewInfo, setPreviewInfo] = useState(null);
  const [range, setRange] = useState([
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: "selection",
    },
  ]);

  const onChangeSearchValue = (e) => {
    let value = e.target.value;
    setSearchValue(value);
  };

  const onSelectItem = (e) => {
    setSelectedValue(e.target.value);
  };

  const openDeleteModal = (data) => {
    setShowDeleteModal(true);
    setDeletePayload(data?.id);
  };
  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setDeletePayload(null);
  };
  const openPreviewModal = (record) => {
    setShowPreviewModal(true);
    setPreviewInfo(record);
  };
  const closePreviewModal = () => {
    setShowPreviewModal(false);
    setPreviewInfo(null);
  };
  const handleDelete = () => {
    deleteTwitterPost({ userID: id, postId: deletePayload });
  };

  useEffect(() => {
    if (sortedTwitterData?.length) {
      let twitterData = sortedTwitterData;
      setTwitterData(twitterData);
    }
  }, [sortedTwitterData]);

  useEffect(() => {
    if (sortedTwitterData) {
      const handleFilter = sortedTwitterData.filter(
        (user) =>
          format(new Date(user?.created_at), "dd/MM/yyyy") >=
            format(range[0].startDate, "dd/MM/yyyy") &&
          format(new Date(user.created_at), "dd/MM/yyyy") <=
            format(range[0].endDate, "dd/MM/yyyy")
      );

      if (handleFilter.length <= 0) {
        setTwitterData(sortedTwitterData);
      } else {
        setTwitterData(handleFilter);
      }
    }
  }, [sortedTwitterData, range]);

  useEffect(() => {
    switch (selectedValue) {
      case "scheduled": {
        const scheduledPost = sortedTwitterData.filter(
          (o) => o?.post_status?.toLowerCase() === "scheduled"
        );
        if (scheduledPost.length) {
          setTwitterData(scheduledPost);
        } else {
          setTwitterData(sortedTwitterData);
        }
        break;
      }
      case "published": {
        const publishedPost = sortedTwitterData.filter(
          (o) => o?.post_status?.toLowerCase() === "published"
        );
        if (publishedPost.length) {
          setTwitterData(publishedPost);
        } else {
          setTwitterData(sortedTwitterData);
        }
        break;
      }
      case "pending": {
        const pendingPost = sortedTwitterData.filter(
          (o) => o?.post_status?.toLowerCase() === "pending"
        );
        if (pendingPost.length) {
          setTwitterData(pendingPost);
        } else {
          setTwitterData(sortedTwitterData);
        }
        break;
      }
      case "draft": {
        const draftPost = sortedTwitterData.filter(
          (o) => o?.post_status?.toLowerCase() === "draft"
        );
        if (draftPost.length) {
          setTwitterData(draftPost);
        } else {
          setTwitterData(sortedTwitterData);
        }
        break;
      }
      default: {
        setTwitterData(sortedTwitterData);
        break;
      }
    }
  }, [sortedTwitterData, selectedValue]);

  useEffect(() => {
    if (searchValue.length <= 0) {
      setTwitterData(sortedTwitterData);
    } else if (searchValue.length >= 4) {
      const results = sortedTwitterData.filter((o) =>
        o?.post_details?.caption
          ?.toLowerCase()
          .includes(searchValue?.toLowerCase())
      );
      if (results.length > 0) {
        setTwitterData(results);
      } else {
        setTwitterData(sortedTwitterData);
      }
    }
  }, [searchValue, sortedTwitterData]);

  useEffect(() => {
    if (!deleteTwitterloading && deleteTwitterMessage?.length > 0) {
      closeDeleteModal();
      toast.success(deleteTwitterMessage);
    } else if (!deleteTwitterloading && deleteTwitterError?.length > 0) {
      toast.error(deleteTwitterError);
    }
  }, [deleteTwitterMessage, deleteTwitterError, deleteTwitterloading]);
  const cols = React.useMemo(
    () => [
      {
        Header: "Post",
        accessor: "post_details",
        Cell: (props) => {
          const media_type = props?.row?.original?.media_type;
          return (
            <div className="row-post">
              <div className="post-image">
                {media_type?.toLowerCase() === "image" ? (
                  <img src={props?.value?.media || dummylogo} alt="" />
                ) : (
                  <video src={props?.value?.media} />
                )}
              </div>
              <div className="post-title-name">
                <h2
                  dangerouslySetInnerHTML={{
                    __html: JSON.stringify(
                      truncateText(props?.value?.caption, "120")
                    )
                      ?.replace(/\\n/g, "<br>")
                      ?.replaceAll('"', ""),
                  }}
                />
                {/* <div className='post-user'>
                    <div className="post-user-img"> <img src={props?.value?.media} alt="" /></div>
                    <h2>{props?.value?.user}</h2>
                </div> */}
              </div>
            </div>
          );
        },
      },
      {
        Header: "Post Type",
        accessor: "media_type",
        Cell: (props) => {
          return (
            <h6 className="post-postType text-uppercase">
              {capitalizeWord(props.value) || "___"}
            </h6>
          );
        },
      },
      {
        Header: "Date",
        accessor: "due_date",
        Cell: (props) => (
          <div className="post-date-time">
            <p>{moment(props?.value).format("DD/MM/YYYY")}</p>
            <p>{moment(props?.value).format("h:mm a")}</p>
          </div>
        ),
      },
      {
        Header: "Post Status",
        accessor: "post_status",
        Cell: (props) => (
          <div>
            {props.value?.toLowerCase() === "pending" ? (
              <div className="post-status pending">
                <div></div>
                <p>{capitalizeWord(props.value)}</p>
              </div>
            ) : props.value?.toLowerCase() === "scheduled" ? (
              <div className="post-status scheduled">
                <div></div>
                <p>{capitalizeWord(props.value)}</p>
              </div>
            ) : props.value?.toLowerCase() === "published" ? (
              <div className="post-status published">
                <div></div>
                <p>{capitalizeWord(props.value)}</p>
              </div>
            ) : props.value?.toLowerCase() === "draft" ? (
              <div className="post-status draft">
                <div></div>
                <p>{capitalizeWord(props.value)}</p>
              </div>
            ) : null}
          </div>
        ),
      },
      {
        Header: "Action",
        accessor: "img",
        cellClass: "",
        Cell: (props) => {
          let record = props?.row?.original;
          return (
            <TableDropdown
              actions={[
                {
                  name: "Preview",
                  action: () => openPreviewModal(record),
                },
                {
                  name: "Delete",
                  action: () => openDeleteModal(record),
                },
              ]}
            />
          );
        },
      },
    ],
    // eslint-disable-next-line
    []
  );

  return (
    <>
      <div className="overflow-auto">
        {getOneClientPostLoading ? (
          <BarLoader />
        ) : (
          <>
            <SocialChannelTopNav
              searchValue={searchValue}
              onChange={onChangeSearchValue}
              selectedValue={selectedValue}
              OnSelectItem={onSelectItem}
              range={range}
              setRange={setRange}
            />
            <br />
            {twitterData?.length ? (
              <Table
                columns={cols}
                data={twitterData}
                divided
                defaultPageSize={4}
                pagePosition="left"
                rowOnClick={(record) => openPreviewModal(record)}
              />
            ) : (
              <NoPostSchedule text={"There are no scheduled Twitter posts "} />
            )}
          </>
        )}
      </div>
      <PreviewPost
        open={showPreviewModal}
        handleClose={closePreviewModal}
        record={previewInfo}
        channel="twitter"
      />
      <DeleteModal
        openModal={showDeleteModal}
        setOpenModal={setShowDeleteModal}
        deleteAction={handleDelete}
        deleteloading={deleteTwitterloading}
      />
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    deleteTwitterloading: state?.postSchedule?.loading?.deleteTwitterPost,
    deleteTwitterError: state?.postSchedule?.error?.deleteTwitterPost,
    deleteTwitterMessage: state?.postSchedule?.message?.deleteTwitterPost,
  };
};
export default connect(mapStateToProps, { deleteTwitterPost })(TwitterPost);
